/**
 * Self-drawn 24px icon set (2px rounded strokes, currentColor). Our own glyphs.
 */
import type { SVGProps } from 'react';

const P: Record<string, string> = {
  learn: 'M4 18c3-6 6-2 8-7s5-4 8-7M4 18h4M17 4h3v3',
  playground: 'M12 3l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.4 6.8 19.1l1-5.8L3.5 9.2l5.9-.9z',
  journal: 'M6 3h11a2 2 0 012 2v14a2 2 0 01-2 2H6zM6 3v18M10 8h5M10 12h5',
  studio: 'M4 20V9l8-5 8 5v11zM9 20v-6h6v6M8 10h8',
  spark: 'M12 2l2 7 7 3-7 3-2 7-2-7-7-3 7-3z',
  settings: 'M12 15a3 3 0 100-6 3 3 0 000 6zM19 12l2-1-1-3-2 .2-1.3-1.4.3-2-3-1-1 1.8h-2L9 2.8l-3 1 .3 2L5 7.2 3 7 2 10l1.8 1v2L2 14l1 3 2-.2 1.3 1.4-.3 2 3 1 1-1.8h2l1 1.8 3-1-.3-2 1.3-1.4 2 .2 1-3z',
  close: 'M6 6l12 12M18 6L6 18',
  back: 'M15 5l-7 7 7 7',
  forward: 'M9 5l7 7-7 7',
  play: 'M7 4l13 8-13 8z',
  pause: 'M7 4v16M17 4v16',
  replay: 'M4 12a8 8 0 108-8H8M8 1L4 4l4 4',
  back10: 'M11 5H7a7 7 0 107 7M7 2L4 5l3 3M11 10v6M14 10h3v6h-3z',
  fwd10: 'M13 5h4a7 7 0 11-7 7M17 2l3 3-3 3M8 10v6M11 10h3v6h-3z',
  cc: 'M3 6h18v12H3zM10 10H8v4h2M16 10h-2v4h2',
  music: 'M9 18V5l11-2v13M9 18a3 3 0 11-3-3 3 3 0 013 3zM20 16a3 3 0 11-3-3 3 3 0 013 3z',
  camera: 'M4 7h4l2-3h4l2 3h4v12H4zM12 17a4 4 0 100-8 4 4 0 000 8z',
  gallery: 'M4 4h16v16H4zM4 16l5-5 4 4 3-3 4 4M15 9a1.5 1.5 0 100-3 1.5 1.5 0 000 3z',
  lock: 'M6 11h12v10H6zM8 11V8a4 4 0 018 0v3M12 15v2',
  unlock: 'M6 11h12v10H6zM8 11V8a4 4 0 017.5-2',
  key: 'M14 10a4 4 0 10-4 4M10 14l-7 7M5 19l2 2M7 17l2 2',
  star: 'M12 3l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.4 6.8 19.1l1-5.8L3.5 9.2l5.9-.9z',
  heart: 'M12 20s-7-4.4-9-9a4.6 4.6 0 019-2 4.6 4.6 0 019 2c-2 4.6-9 9-9 9z',
  check: 'M4 12l5 5L20 6',
  plus: 'M12 5v14M5 12h14',
  minus: 'M5 12h14',
  chest: 'M3 10h18v10H3zM3 10l2-5h14l2 5M11 13h2v3h-2z',
  mail: 'M3 6h18v12H3zM3 6l9 7 9-7',
  book: 'M4 5c3-1 6-1 8 1 2-2 5-2 8-1v14c-3-1-6-1-8 1-2-2-5-2-8-1zM12 6v14',
  trophy: 'M8 4h8v5a4 4 0 01-8 0zM8 6H4a3 3 0 004 4M16 6h4a3 3 0 01-4 4M12 13v4M8 21h8M9 17h6',
  users: 'M9 11a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM2 20c0-4 3-6 7-6s7 2 7 6M16 4a3.5 3.5 0 010 7M18 14c2.5.5 4 2.5 4 6',
  share: 'M12 15V3M7 8l5-5 5 5M5 13v8h14v-8',
  sticker: 'M4 4h16v10l-6 6H4zM14 20v-6h6',
  layout: 'M3 4h18v16H3zM3 12h18M12 4v16',
  theme: 'M12 3a9 9 0 100 18c1 0 1.5-.8 1-1.7-.6-1-.2-2.3 1-2.3h2a5 5 0 005-5c0-5-4-9-9-9zM7.5 11a1 1 0 100-2M12 7.5a1 1 0 100-2M16.5 10a1 1 0 100-2',
  trash: 'M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3',
  edit: 'M4 20h4L19 9l-4-4L4 16zM13 7l4 4',
  flip: 'M12 3v18M4 7v10l5-5zM20 7v10l-5-5z',
  grid: 'M3 3h18v18H3zM9 3v18M15 3v18M3 9h18M3 15h18',
  soundOn: 'M4 9h4l5-4v14l-5-4H4zM16 9a4 4 0 010 6M19 6a8 8 0 010 12',
  soundOff: 'M4 9h4l5-4v14l-5-4H4zM17 9l5 6M22 9l-5 6',
  globe: 'M12 21a9 9 0 100-18 9 9 0 000 18zM3 12h18M12 3c3 3 3 15 0 18M12 3c-3 3-3 15 0 18',
  crown: 'M3 8l4 4 5-7 5 7 4-4-2 11H5zM5 21h14',
  pencil: 'M4 20l2-6L16 4l4 4L10 18zM14 6l4 4M4 20l6-2',
  bolt: 'M13 2L4 14h7l-1 8 9-12h-7z',
  paw: 'M8 10a2 2 0 100-4 2 2 0 000 4zM16 10a2 2 0 100-4 2 2 0 000 4zM5 14a2 2 0 100-4 2 2 0 000 4zM19 14a2 2 0 100-4 2 2 0 000 4zM12 13c-3 0-5 3-5 5s2 3 5 3 5-1 5-3-2-5-5-5z',
  leaf: 'M5 19C5 9 10 4 20 4c0 10-5 15-15 15zM5 19l9-9',
  smile: 'M12 21a9 9 0 100-18 9 9 0 000 18zM8 14c1 2 2.5 3 4 3s3-1 4-3M9 9.5v.5M15 9.5v.5',
  dice: 'M6 3h12a3 3 0 013 3v12a3 3 0 01-3 3H6a3 3 0 01-3-3V6a3 3 0 013-3zM8 8h.01M16 8h.01M12 12h.01M8 16h.01M16 16h.01',
  sparkle: 'M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8zM19 16l.8 2.2 2.2.8-2.2.8L19 22l-.8-2.2-2.2-.8 2.2-.8z',
  cupcake: 'M5 12h14l-2 8H7zM6 12a6 6 0 0112 0M12 6V4',
  heartFill: '',
  menu: 'M4 6h16M4 12h16M4 18h16',
  help: 'M12 21a9 9 0 100-18 9 9 0 000 18zM9.5 9a2.5 2.5 0 015 .5c0 2-2.5 2-2.5 4M12 17v.5',
  logout: 'M15 4h4v16h-4M10 8l-4 4 4 4M6 12h11',
  mic: 'M12 15a3 3 0 003-3V6a3 3 0 00-6 0v6a3 3 0 003 3zM5 11a7 7 0 0014 0M12 18v3',
  rotate: 'M4 12a8 8 0 0114-5.3M20 12a8 8 0 01-14 5.3M18 3v4h-4M6 21v-4h4',
  crop: 'M6 2v16h16M2 6h16v16',
  filter: 'M3 5h18l-7 8v6l-4 2v-8z',
  eye: 'M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12zM12 15a3 3 0 100-6 3 3 0 000 6z',
  timer: 'M12 21a8 8 0 100-16 8 8 0 000 16zM12 9v4l3 2M9 2h6',
  bell: 'M6 16V11a6 6 0 0112 0v5l2 2H4zM10 20a2 2 0 004 0',
  gift: 'M3 9h18v4H3zM5 13v8h14v-8M12 9v12M12 9c-2-4-6-4-6-1s6 1 6 1zM12 9c2-4 6-4 6-1s-6 1-6 1z',
  wall: 'M3 4h18v16H3zM7 8h4v4H7zM14 8h3v6h-3z',
  scan: 'M4 8V4h4M16 4h4v4M20 16v4h-4M8 20H4v-4M4 12h16',
  paper: 'M6 3h9l4 4v14H6zM15 3v4h4',
  library: 'M4 4h4v16H4zM10 4h4v16h-4zM16 5l3-1 3 15-3 1z',
};

export type IconName = keyof typeof P;

/** 24-unit grid, 2-unit stroke (ART-BIBLE §7). The stroke is nudged by size so it reads ≥ 1.5 px at 16 px and does
 *  not turn heavy at 48-64 px; CSS-resized icons (`.icon-btn svg`) keep the 24 px design size. */
const strokeFor = (size: number) => (size <= 18 ? 2.3 : size >= 40 ? 1.75 : 2);

export function Icon({ name, size = 24, className, ...rest }: { name: IconName; size?: number } & SVGProps<SVGSVGElement>) {
  const cls = className ? `ui-icon ${className}` : 'ui-icon';
  if (name === 'heartFill')
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden className={cls} {...rest}>
        <path d={P.heart} fill="currentColor" />
      </svg>
    );
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeFor(size)} strokeLinecap="round" strokeLinejoin="round" aria-hidden className={cls} {...rest}>
      <path d={P[name]} />
    </svg>
  );
}

/** The spark currency glyph: a pencil tip leaving a five-point star (our own mark). */
export function SparkGlyph({ size = 22 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden>
      <path d="M12 2.5l2.3 5.2 5.6.6-4.2 3.8 1.2 5.5L12 14.8l-4.9 2.8 1.2-5.5L4.1 8.3l5.6-.6z" fill="#FFC23A" stroke="#E08A00" strokeWidth="1.2" strokeLinejoin="round" />
      <path d="M12 17.5l-1.6 4h3.2z" fill="#FF7A1A" />
    </svg>
  );
}
